import React from 'react'
import PropTypes from 'prop-types'
 import { Link } from 'react-router-dom';

export default function NavBar(props) {
  return (
    
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode === 'light' ? 'light' : props.mode === 'red' ? 'danger' : props.mode === 'dark' ? 'success' : 'primary'}`}>
  
             
    <div className="container-fluid">
     <Link className="navbar-brand" to="/" style={{ color: props.mode === 'light' ? 'black' : 'white' }}>{props.title}</Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
          {/* <Link className="nav-link active" aria-current="page" to="/" style={{ color: props.mode === "dark" || props.mode === "red" || props.mode === "blue" ? "white" : "black" }}>Home</Link> */}
          <Link className="nav-link active" aria-current="page" to="/" style={{ color: props.mode === "dark" || props.mode === "red" || props.mode === "blue" ? "white" : "black" }}>Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about"style={{ color: props.mode === 'light' ? 'black' : 'white' }}>{props.aboutText}</Link>
          </li>
        </ul>
        {/* <form className="d-flex" role="search">
          <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
          <button className="btn btn-outline-success" type="submit">Search</button>
        </form> */}
        
       <div className={`form-check form-switch text-${props.mode==='light'? 'Dark' : 'light'}` } >
  <input className="form-check-input" onClick={props.toggleMode} type="checkbox"  role="switch" id="greenModeSwitch"/>
  <label className="form-check-label"  htmlFor="greenModeSwitch" >Enable GreenMode</label>
   </div>
       <div className={`form-check form-switch text-${props.mode==='light'? 'Dark' : 'light'}`} >
          <input className="form-check-input " onClick={props.toggleRedMode} type="checkbox"  role="switch" id="redModeSwitch"/>
          <label className="form-check-label"  htmlFor="redModeSwitch">Enable Redmode</label>
    </div>
       <div className={`form-check form-switch text-${props.mode==='light'? 'Dark' : 'light'}`} >
          <input className="form-check-input" onClick={props.toggleBlueMode} type="checkbox"  role="switch" id="blueModeSwitch"/>
          <label className="form-check-label"  htmlFor="blueModeSwitch">Enable Bluemode</label>
    </div>

      </div>
    </div>
  </nav>
  )
};
NavBar.propTypes={title:PropTypes.string.isRequired,   //is required state that this must be filled  and cant be left empty
                  aboutText:PropTypes.string
}

NavBar.defaultProps = {   //if no props are passed this is executed as default in place of title and about
    title:'set title',
    aboutText:'about Us'  
};
